import apiService from "./api";

export type JourneyStageCategory = 'MEDIUNICA' | 'RITUALISTICA' | 'FORMACAO';

export interface JourneyStage {
	id: string;
	name: string;
	description?: string | null;
	order: number;
	category: JourneyStageCategory;
	requiredJourneyStageId?: string | null;
	requiredJourneyStage?: { id: string; name: string } | null;
	createdAt: string;
	updatedAt: string;
}

export interface JourneyStageFilter {
	search?: string;
	page?: number;
	limit?: number;
	orderBy?: string;
	order?: "asc" | "desc";
	name?: string;
}

export interface PaginatedResponse<T> {
	data: T[];
	meta: {
		total: number;
		page: number;
		limit: number;
		totalPages: number;
		hasNextPage?: boolean;
		hasPreviousPage?: boolean;
	};
}

export interface JourneyStageStats {
	totalStages: number;
	totalPeopleInJourney: number;
	averagePeoplePerStage: number;
	stageDistribution: Array<{
		id: string;
		name: string;
		activeCount: number;
		inactiveCount: number;
		_count: {
			membersAssignments: number;
		};
	}>;
}

// JourneyStage CRUD operations
export const getJourneyStages = async (
	filter: JourneyStageFilter = {}
): Promise<PaginatedResponse<JourneyStage>> => {
	// Remover parâmetros null ou undefined
	const params: any = Object.entries(filter).reduce(
		(acc: Record<string, any>, [key, value]) => {
			if (value !== null && value !== undefined) {
				acc[key] = value;
			}
			return acc;
		},
		{}
	);

	try {
		const response = await apiService.get("/journey-stages", { params });

		if (response) {
			return response;
		} else {
			console.warn("Resposta inválida ao buscar etapas da jornada");
			return {
				data: [],
				meta: {
					total: 0,
					page: Number(params.page) || 1,
					limit: Number(params.limit) || 10,
					totalPages: 0,
				},
			};
		}
	} catch (error) {
		console.error("Erro na requisição getJourneyStages:", error);
		return {
			data: [],
			meta: {
				total: 0,
				page: Number(params.page) || 1,
				limit: Number(params.limit) || 10,
				totalPages: 0,
			},
		};
	}
};

export const getJourneyStageById = async (
	id: string
): Promise<JourneyStage> => {
	const response = await apiService.get(`/journey-stages/${id}`);
	return response;
};

export const createJourneyStage = async (
	stage: Partial<JourneyStage>
): Promise<JourneyStage> => {
	const response = await apiService.post("/journey-stages", stage);
	return response;
};

export const updateJourneyStage = async (
	id: string,
	stage: Partial<JourneyStage>
): Promise<JourneyStage> => {
	const response = await apiService.patch(`/journey-stages/${id}`, stage);
	return response;
};

export const deleteJourneyStage = async (id: string): Promise<void> => {
	await apiService.delete(`/journey-stages/${id}`);
};

export const reorderJourneyStages = async (ids: string[]): Promise<void> => {
	await apiService.patch("/journey-stages/reorder", { ids });
};

export const getJourneyStageStats = async (): Promise<JourneyStageStats> => {
	const response = await apiService.get("/journey-stages/stats");
	return response;
};
